import { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { SignUpForm } from 'components/Auth/SignUpForm';
import { SignUpFormData } from 'types/auth';
import { registerUser } from 'services/authService';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';
import { useSelector } from 'react-redux';
import { getUser } from 'store/session/selectors';
import { useDidMount } from 'hooks/useDidMount';

export const SignUpPage = () => {
    const user = useSelector(getUser);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const signUpHandler = useCallback(
        (values: SignUpFormData) => {
            setIsLoading(true);
            registerUser(values)
                .then(() => navigate(PATH.LOGIN))
                .finally(() => setIsLoading(false));
        },
        [navigate],
    );

    useDidMount(() => {
        if (user) {
            navigate(PATH.ROOT);
        }
    });

    return (
        <Box px={2.5} py={2} display="flex" width="100%" height="100%" alignItems="center" justifyContent="center">
            <Card title="Sign Up">
                <SignUpForm onSignUp={signUpHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
